import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Common } from '@thecvlb/design-system';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';

import PreviewCarousel from 'widgets/LoginPreview/PreviewCarousel';

import { LINK_TO_MEMBERSHIP } from 'constants/externalLinks';

import BgVideo from 'assets/auth_bg.mp4';
import VideoFallbackImage from 'assets/images/auth/sign-in/login-bg-1.webp';
import Logo from 'assets/images/logos/signin.svg?react';

const LoginPreview = () => {
  const [, setSearchParams] = useSearchParams();
  const [isFirstSlide, setIsFirstSlide] = useState(true);

  return (
    <div className="h-full max-h-screen overflow-hidden">
      <AnimatePresence>
        <motion.div
          className={classNames(
            'signup-video',
            !isFirstSlide ? 'after:opacity-1' : 'after:opacity-0'
          )}
        >
          <video
            className="absolute left-0 top-0 z-0 size-full object-cover"
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={BgVideo} type="video/mp4" />
            <img alt="background" src={VideoFallbackImage} />
          </video>
          <div
            className="absolute top-0 z-[1] h-1/4 w-full"
            style={{
              background:
                'linear-gradient(180deg, rgba(0.46, 31.13, 41.36, 0.58) 0%, rgba(0.46, 31.13, 41.36, 0) 100%)'
            }}
          />
          <div
            className="absolute bottom-0 z-[1] h-1/2 w-full"
            style={{
              background:
                'linear-gradient(0deg, rgba(0.46, 31.13, 41.36, 0.58) 0%, rgba(0.46, 31.13, 41.36, 0) 100%)'
            }}
          />
          <header className="absolute inset-x-0 top-6 z-30 flex w-full items-center">
            <Logo className="mx-auto flex h-12" />
          </header>
          <PreviewCarousel onChange={(i) => setIsFirstSlide(i === 0)} />
          <div className="absolute bottom-4 z-30 w-full space-y-2 px-4">
            <Common.Button
              color="blue-alt"
              dataTestId="sign_up"
              fullWidthOnMobile
              onClick={() => window.open(LINK_TO_MEMBERSHIP, '_blank')}
            >
              Create an account
            </Common.Button>
            <Common.Button
              className="text-white"
              dataTestId="sign_in"
              style="text-only"
              fullWidthOnMobile
              onClick={() => setSearchParams({ with: 'all' })}
            >
              Sign in
            </Common.Button>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default LoginPreview;
